<template>
	<!-- <span>테스트</span> -->
	<!-- 테이블 사용시 sf-data-table을 사용 태그 안에 옵션들로 설정함 -->
	<sf-data-table
		ref="refUploadFormTable"
		:columns="columns"
		:rows="uploadFormList"
		:addRowDatas="addRowDatas"
		@row-eblclick="rowDblClick"
		@select="updateRef"
		cell-cass-name="content__cusror-pointer"
		:excel="isButton_(scrId, 'EX')"
		selection
		paging
		@changedPage="onChangePage"
		:pageUnit="pagingInfo.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="pagingInfo.totalSize || screen.defaultPageSize"
	>
		<template v-slot:actionsLeft>
			<!-- <sf-button line v-if="isButton_(scrId, 'AD')" icon="square-plue" :onClick="addAction">{{ getMessage_('MWCC000232') }}</sf-button>
			<sf-button line v-if="isButton_(scrId, 'AD')" icon="file" :onClick="() => onClickButton('save')">{{
				getMessage_('MWCC000138')
			}}</sf-button> -->
			<sf-button line v-if="isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="() => onClickButton('delete')">{{
				getButtonMsg_(scrId, 'CD')
			}}</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { serviceComputed, serviceMethods } from '@qms/UploadForm/store/helpers';
import { rootComputed, rootMethods } from '@/store/common/helpers';
//import { rootComputed } from '@/store/helpers';

import * as yup from 'yup';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			addRowDatas: [],
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
		// console.log('tableView ::::' + this.scrId);
		// console.log('tableview screen ::', this.screen);
	},
	computed: {
		...serviceComputed,
		...rootComputed,
		rows() {
			return this.tableInfoList;
		},
		columns() {
			return [
				{ label: 'No.', prop: 'rnum', width: '50', sortable: false },
				{ label: this.getMessage_('MWCC000141'), prop: 'status', width: '90px' },
				{
					label: this.getMessage_('MWCC000538') /**테이블ID*/,
					prop: 'gqmsSeq',
					minWidth: '100px',
					form: {
						type: 'input',
						maxLength: 100
					},
					clickEvent: this.scrNameClick,
					highlight: true
				},
				{
					label: this.getMessage_('QWCC000908') /**테이블 코맨트*/,
					prop: 'gqmsTitle',
					minWidth: '150px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('QWCC000909') /**컬럼ID*/,
					prop: 'gqmsConts',
					minWidth: '100px',
					form: {
						type: 'input',
						maxLength: 100
					},
					clickEvent: this.scrNameClick2
				}
				// { label: this.getMessage_('MWCC000146') /**등록일*/, prop: 'displayRegDt', minWidth: '100px' },
				// { label: this.getMessage_('MWCC000005') /**등록자*/, prop: 'regId', width: '100px' },
				// { label: this.getMessage_('MWCC000171') /**수정일*/, prop: 'displayChgDt', minWidth: '100px' },
				// { label: this.getMessage_('MWCC000172') /**수정자*/, prop: 'chgId', width: '100px' }
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		addAction() {
			/* default Data가 없을경우 한행 추가 */
			// let addRowData = { ...this.addRowData };
			// this.rows.unshift(addRowData);
			// this.$refs.refUploadFormTable.getTable().toggleRowSelection(addRowData);

			/* default Data가 있을경우 make를 사용하여 추가 */
			this.makeAddDatas();
			let addRowData = { ...this.addRowDatas };
			this.rows.unshift(addRowData);
			this.$refs.refUploadFormTable.getTable().toggleRowSelection(addRowData);
		},
		getSelectedRows() {
			//const defaultObj = this.commCdTypeSchema.cast();
			const rows = this.$refs.refTableInfoTable.getSelectedRows().map(row => _(row).omitBy(_.isNull).omitBy(_.isUndefined).value());
			return rows;
		},
		makeAddDatas() {
			// 단건은  {} 이지만 다건은 [{},{}] 식으로 처리한다.
			this.addRowDatas = {
				status: 'I',
				gqmsSeq: '',
				gqmsTitle: '',
				gqmsConts: ''
			};
		},
		// onClickRegister() {
		// 	this.setSelectedRow({ open: true });
		// },
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.$sf_toggleLoading(true);
			this.getUploadFormList_({ ...this.searchParams, currentPage: currentPageVal, pageUnit: pageUnitVal })
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
			// this.$store
			// 	.dispatch('tableInfoStore/select_', { currentPage: currentPageVal, pageUnit: pageUnitVal })
			// 	.finally(() => this.$sf_toggleLoading(false));
		},
		updateRef() {
			this.SET({ key: 'refTableInfoTable', value: this.$refs.refTableInfoTable });
		},
		rowDblClick(row, column, devent) {
			this.setSelectedRow({ ...row, open: true });
		},
		onClickButton(action) {
			if (this.getSelectedRows().length === 0) {
				this.$sf_showMessage({
					icon: 'error',
					message: this.getMessage_('MWCC000109')
				});
				return;
			}
			const messageCode = {
				save: 'MWCC000501',
				delete: 'MWCC000108'
			}[action];
			const clickFn = {
				save: this.update,
				delete: this.delete
			}[action];
			const message = this.getMessage_(messageCode);
			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				message,
				buttons: [{ title: 'Confirm', clickFn }] //this.getMessage_('MWCC000203')
			});
		},
		async scrNameClick(row) {
			this.$sf_toggleLoading(true);

			const fileList = [];
			let fileInfoList = [];
			let imgPreviewList = [];
			let imgPreviewName = [];
			let img1Path = '';
			let img2Path = '';

			if (row.fileInfo) {
				const fileArray = row.fileInfo.split('|||');
				fileArray.forEach(element => {
					//console.log('element', element);
					const fileInfo = element.split('*');
					const fileName = fileInfo[0];
					const origFileName = fileInfo[0];
					const fileExt = fileInfo[1];
					const fileSize = fileInfo[2];
					const fileId = fileInfo[3];
					const fileSeq = fileInfo[4];
					fileInfoList.push({ origFileName, fileName, fileExt, fileSize, fileId, fileSeq });

					//console.log('fileExt', fileExt.toUpperCase());
					if ('|JPG|PNG|GIF|'.indexOf(fileExt.toUpperCase()) > -1) {
						this.imgDownload_({ fileId: fileId, fileSeq: fileSeq }).then(file => {
							fileList.push(file);
						});
					}
				});
			}

			if (row.imgId1) {
				//console.log('imgId1', row.imgId1);
				/* 이미지 관련 파일 url생성 */
				await this.imgDownload_({ fileId: row.imgId1, fileSeq: 1 }).then(file => {
					img1Path = file.url;
					imgPreviewList.push(file.url);
					imgPreviewName.push(file.name);
					//console.log('img1Path값', img1Path);
				});
			}

			if (row.imgId2) {
				await this.imgDownload_({ fileId: row.imgId2, fileSeq: 1 }).then(file => {
					img2Path = file.url;
					imgPreviewList.push(file.url);
					imgPreviewName.push(file.name);
					//console.log('img2Path값', img2Path);
				});
			}

			//this.editRow = row;
			//console.log('tableView22');
			//console.log({ ...this.UploadFormDetailValue, fileList });

			this.defaultAssign_({ key: 'UploadFormDetailValue', value: { ...this.UploadFormDetailValue, fileList } });
			this.setDetailValue_({ key: 'gqmsSeq', value: row.gqmsSeq });
			this.setDetailValue_({ key: 'gqmsTitle', value: row.gqmsTitle });
			this.setDetailValue_({ key: 'gqmsConts', value: row.gqmsConts });
			this.setDetailValue_({ key: 'regId', value: row.regId });
			this.setDetailValue_({ key: 'imgFile1', value: row.imgFile1 || [] });
			this.setDetailValue_({ key: 'imgFile2', value: row.imgFile2 || [] });
			this.setDetailValue_({ key: 'imgId1', value: row.imgId1 });
			this.setDetailValue_({ key: 'imgId2', value: row.imgId2 });
			this.setDetailValue_({ key: 'fileId', value: row.fileId });
			this.setDetailValue_({ key: 'img1Url', value: img1Path });
			this.setDetailValue_({ key: 'img2Url', value: img2Path });
			this.setDetailValue_({ key: 'imgPreviewList', value: imgPreviewList });
			this.setDetailValue_({ key: 'imgPreviewName', value: imgPreviewName });
			// this.setDetailValue_({ key: 'file2Id', value: row.file2Id });
			this.setDetailValue_({ key: 'fileInfo', value: fileInfoList });
			this.defaultAssign_({ key: 'UploadFormDetail', value: true });
			this.$sf_toggleLoading(false);

			//console.log('데이터 입력 완료>>>>>>>>>>>>>>>>>>>>', this.UploadFormDetailValue);
		},
		async scrNameClick2(row) {
			this.getSelectOne_(row.gqmsSeq)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});

			// this.setDetailValue_({ key: 'gqmsSeq', value: row.gqmsSeq });
		}
	}
};
</script>

<style>
.content__cusror-pointer {
	cursor: pointer;
	user-select: none;
}
.notification___nowrap span {
	white-space: nowrap;
}
</style>
